
export default {
    install (Vue, store ) {
        if (!store) {
            console.error('Vuex store not defined!');
        }

        Vue.prototype.$modal = {
            confirmModal: function (message) {
                return new Promise(function (resolve, reject) {
                    store.commit('confirmationModal/setModalDescription', message, {root: true});
                    store.commit('confirmationModal/setIsVisible', true, {root: true});
                    var subscription = {};
                    subscription.unsubscribe = store.subscribeAction(({ type, payload }, state) => {

                        if (type == 'confirmationModal/confirmModal' || type == 'confirmationModal/cancelModal') {
                            subscription.unsubscribe();
                            store.commit('confirmationModal/setIsVisible', false, {root: true});
                            if (type == 'confirmationModal/confirmModal') {
                                resolve(payload);
                            }
                            if (type == 'confirmationModal/cancelModal') {
                                // Verify what to do
                            }
                            //store.unsubscribe();
                            //subscribed.
                        }
                    });
                });
            },
            entityModal: function (entity, entityObject) {
                return new Promise(function (resolve, reject) {
                    store.commit('entityModal/setupEntityModal', {entity, entityObject}, {root: true});
                    store.commit('entityModal/setIsVisible', true, {root: true});
                    var subscription = {};
                    subscription.unsubscribe = store.subscribeAction(({ type, payload }, state) => {

                        if (type == 'entityModal/confirmModal' || type == 'entityModal/cancelModal') {
                            subscription.unsubscribe();
                            store.commit('entityModal/setIsVisible', false, {root: true});
                            if (type == 'entityModal/confirmModal') {
                                resolve(payload);
                            }
                            if (type == 'entityModal/cancelModal') {
                                // Verify what to do
                            }
                            //store.unsubscribe();
                            //subscribed.
                        }
                    });
                });
            },
            uploadModal: function () {
                store.commit('uploadModal/setIsVisible', true, {root: true});
            }
        }

    }
}